export default __webpack_public_path__ + "static/media/NaiaraLovelace.e70544f2.png";